"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _clsx = _interopRequireDefault(require("clsx"));

var _Button = _interopRequireDefault(require("@material-ui/core/Button"));

var _Typography = _interopRequireDefault(require("@material-ui/core/Typography"));

var _useLocals = _interopRequireDefault(require("@micado-digital/react-ui/hooks/useLocals"));

var _Local = _interopRequireDefault(require("@micado-digital/react-ui/components/Local"));

var _de = _interopRequireDefault(require("../../../locals/de.json"));

var _en = _interopRequireDefault(require("../../../locals/en.json"));

var _it = _interopRequireDefault(require("../../../locals/it.json"));

var _Error = _interopRequireDefault(require("./Error.styles"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Error = function Error(_ref) {
  var _ref$lang = _ref.lang,
      lang = _ref$lang === void 0 ? "de" : _ref$lang,
      onClick = _ref.onClick;
  var css = (0, _Error.default)();
  var l = (0, _useLocals.default)({
    lang: lang,
    res: {
      de: _de.default,
      en: _en.default,
      it: _it.default
    }
  });

  var svg = /*#__PURE__*/_react.default.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 238.4 162.8"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M237.7 99.1l-56.8-7-1.4 11.3 1.7.2-5.1 41.9 53.3 6.5 5.1-41.9 1.7.2 1.5-11.2zm-54.5-4l51.5 6.3-.8 6.1-51.5-6.3.8-6.1zm43.9 54.1l-48-5.9 4.8-39.3 48 5.9-4.8 39.3zm-28-31.8l14 1.7c1.7.2 4.2-1.8 4.4-3.4s-1.8-4.2-3.4-4.4l-14-1.7c-1.7-.2-4.2 1.8-4.4 3.4s1.7 4.2 3.4 4.4zm.6-5.2l13.9 1.7c.5.4 1 .9 1.2 1.5-.4.5-.9.9-1.5 1.1l-13.9-1.7c-.5-.4-1-.9-1.2-1.5.4-.5.9-.9 1.5-1.1z",
    className: css.pathDefault
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M234.8 38L190 43.5l1.2 9.4 1.6-.2 4 32.2 41.7-5.1-4-32.2 1.6-.2-1.3-9.4zm-42.1 7.6l40.1-4.9.6 4.7-40.1 4.9-.6-4.7zm43.1 32.2l-37 4.5-3.7-29.9 37-4.5 3.7 29.9zm-26.7-18.3l10.5-1.3c1.7-.2 2.9-1.8 2.7-3.6-.2-1.7-1.8-2.9-3.5-2.7l-10.5 1.3c-1.7.2-3 1.7-2.8 3.5s1.7 3 3.6 2.8c-.1 0-.1 0 0 0zm-.4-3.9l10.4-1.3c.4-.1.8.2.9.7.1.4-.2.8-.7.9h-.1l-10.4 1.3c-.4.1-.8-.2-.9-.7s.3-.9.8-.9c-.1 0-.1 0 0 0z",
    className: css.pathDefault
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M143.2 3.4c-11.8 4.9-21.1 14.5-25.6 26.5l1.7 4.2 4.7-1.9c3.8-10.1 11.7-18.2 21.7-22.4 20.2-8.2 43.5 1.8 51.9 22.5l6.3-2.6c-9.8-24.2-37.1-36-60.7-26.3zm-33.7 16.2l-6.3 2.6 10.5 25.7 25.1-10.3-2.6-6.4-18.8 7.7-7.9-19.3z",
    className: css.pathHighlight
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M67.9 139.3c-5.1 0-9.5-3.7-10.4-8.7L54 110.7h80.3c7.8 0 14.5-5.3 16.3-12.8l12.2-50.6-3.6-.9L147 97c-1.4 5.9-6.7 10-12.7 10h-81L38.8 24.8c-2.2-12.8-13.3-22-26.3-22H9.3C4.2 2.8 0 6.9 0 12.1c0 5.1 4.2 9.3 9.3 9.3 5.1 0 9.3-4.2 9.3-9.3 0-1.8-.5-3.6-1.6-5.2 9.3 1.8 16.5 9.2 18.1 18.5l18.7 105.7c1.2 6.8 7.1 11.8 14.1 11.8-4.5 4.7-4.3 12.2.4 16.7s12.2 4.3 16.7-.4c4.3-4.6 4.3-11.7 0-16.3h35.1c-4.5 4.7-4.3 12.2.4 16.7s12.2 4.3 16.7-.4c4.3-4.6 4.3-11.7 0-16.3H151v-3.7H67.9zM9.3 17.7c-3.1 0-5.6-2.5-5.6-5.6 0-3.1 2.5-5.6 5.6-5.6 3.1 0 5.6 2.5 5.6 5.6 0 3.1-2.5 5.6-5.6 5.6zM84.5 151c0 4.5-3.6 8.1-8.1 8.1s-8.1-3.6-8.1-8.1 3.6-8.1 8.1-8.1 8.1 3.7 8.1 8.1zm52.2 0c0 4.5-3.6 8.1-8.1 8.1s-8.1-3.6-8.1-8.1 3.6-8.1 8.1-8.1 8.1 3.7 8.1 8.1zm-8.1 2.5c1.4 0 2.5-1.1 2.5-2.5s-1.1-2.5-2.5-2.5-2.5 1.1-2.5 2.5 1.2 2.5 2.5 2.5zm-52.2 0c1.4 0 2.5-1.1 2.5-2.5s-1.1-2.5-2.5-2.5-2.5 1.1-2.5 2.5 1.1 2.5 2.5 2.5z",
    className: css.pathDefault
  }));

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "mco-shop-cart-error"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.svgWrapper, "mco-shop-cart-error__svg-wrapper")
  }, svg), /*#__PURE__*/_react.default.createElement("h2", {
    className: (0, _clsx.default)(css.headline, "mco-shop-cart-error__headline")
  }, /*#__PURE__*/_react.default.createElement(_Local.default, {
    identifier: "reactShop.cart.error.headline",
    l: l
  })), /*#__PURE__*/_react.default.createElement(_Typography.default, {
    className: (0, _clsx.default)(css.text, "mco-shop-cart-error__text"),
    variant: "body1"
  }, /*#__PURE__*/_react.default.createElement(_Local.default, {
    identifier: "reactShop.cart.error.text",
    l: l
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.buttonWrapper, "mco-shop-cart-error__button-wrapper")
  }, /*#__PURE__*/_react.default.createElement(_Button.default, {
    color: "primary",
    variant: "contained",
    onClick: onClick
  }, /*#__PURE__*/_react.default.createElement(_Local.default, {
    identifier: "reactShop.cart.error.button",
    l: l
  }))));
};

var _default = Error;
exports.default = _default;